export default [
  {
    path: '/quest-daily',
    component: () => import('./views/Index'),
    name: 'quest-daily',
    redirect: { name: 'quest-daily-list' },
    children: [
      {
        path: '',
        name: 'quest-daily-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:daily_id',
        name: 'quest-daily-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
